module.exports = __webpack_public_path__ + "static/media/07-03.3bb73e7d.png";